import React from "react";
import { Box } from "@material-ui/core";

import { useTranslation } from "react-i18next";

import DateSelector from "components/DateSelector";
import CountrySelector from "components/CountrySelector";

import PeriodSelector from "components/PeriodSelector";

export default function SelectionBar({
  selectedDate,
  onSelectedDateChange,
  minDate,
  maxDate,
  country,
  onCountryChange,
  useLabels = true,
  // baselineDate,
  // onBaselineDateChange,
  period,
  onPeriodChange,
}) {
  const { t } = useTranslation();

  return (
    <Box pl={1} pr={1}>
      <Box display="flex" direction="row">
        <Box p={1} flexGrow={1}>
          <CountrySelector
            label={useLabels ? t("countrySelector.label") : undefined}
            country={country}
            onCountryChange={onCountryChange}
          />
        </Box>
        <Box p={1} width={1 / 4}>
          <PeriodSelector
            label={t("period.label")}
            value={period}
            onChange={onPeriodChange}
          />
          {/* <DateSelector
            label={useLabels ? t("baselineDate.label") : undefined}
            date={baselineDate}
            onDateChange={onBaselineDateChange}
            minDate={minDate}
            maxDate={maxDate}
          /> */}
        </Box>
        <Box p={1} width={1 / 4}>
          <DateSelector
            label={useLabels ? t("selectedDate.label") : undefined}
            date={selectedDate}
            onDateChange={onSelectedDateChange}
            minDate={minDate}
            maxDate={maxDate}
          />
        </Box>
      </Box>
    </Box>
  );
}
